import { FunctionComponent } from 'react';
import { Headline, Button, Div, BodyText, Title, Gutter, GridBag } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { createAuthenticationUrl } from '../../../utils';
import { RootState } from '../../../store/reducers';

const LoginNewUser: FunctionComponent = () => {
  const { t } = useTranslation('authentication');

  const requestedPath = useSelector((state: RootState) => state.authentication.requestedPath);

  const handleLoginClick = (): void => {
    globalThis.location.href = createAuthenticationUrl(requestedPath || undefined);
  };

  return (
    <Div padding={{ top: 'xxlg', horizontal: 'xxlg' }}>
      <Headline size="md" block>
        {t('LoginNewUserComponent.title')}
      </Headline>
      <Title size="sm" block padding={{ top: 'xlg', bottom: 'lg' }}>
        {t('LoginNewUserComponent.emailQuestion')}
      </Title>
      <GridBag>
        <GridBag.Item sm={1}>
          <Title size="xs">{t('LoginNewUserComponent.positiveEmailOption')}</Title>
        </GridBag.Item>
        <GridBag.Item sm={11}>
          <BodyText inlineBlock padding={{ left: 'sm' }}>
            {t('LoginNewUserComponent.positiveEmailInstruction')}
          </BodyText>
        </GridBag.Item>
      </GridBag>
      <Gutter size="lg" />
      <GridBag>
        <GridBag.Item sm={1}>
          <Title size="xs">{t('LoginNewUserComponent.negativeEmailOption')}</Title>
        </GridBag.Item>
        <GridBag.Item sm={11}>
          <BodyText inlineBlock padding={{ left: 'sm' }}>
            {t('LoginNewUserComponent.negativeEmailInstruction')}
          </BodyText>
        </GridBag.Item>
      </GridBag>
      <BodyText margin={{ vertical: 'xlg' }}>{t('LoginNewUserComponent.additionalInstruction')}</BodyText>
      <Button variant="secondary" size="lg" onClick={handleLoginClick}>
        {t('LoginNewUserComponent.loginButton')}
      </Button>
    </Div>
  );
};

export default LoginNewUser;
